import React, { useState, useEffect } from 'react';
import API from '../../../pages/Api';
import { toast } from 'react-toastify';
import { FaEdit, FaPlus, FaTimes, FaCheckCircle, FaMinusCircle } from 'react-icons/fa';
import TableContainer from '../../common/Tablecontainer';

const AddFeedbackStatementDetails = () => {
    
    const [courses, setCourses] = useState([]);
    const [users, setUsers] = useState([]);
    
    const [tableKey, setTableKey] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');

    const [formData, setFormData] = useState({
        courseid: '',
        feedbacktitle: '',
        feedbackdesc: '',
        userid: ''
    });

    
    const refreshTableData = () => {
        setTableKey(prev => prev + 1);
    };
    const isMobile = window.innerWidth < 768;

    const [list, setList] = useState([]);
    const [loadingCards, setLoadingCards] = useState(false);
    const [mobilePage, setMobilePage] = useState(1);
    const [mobileTotalPages, setMobileTotalPages] = useState(1);

    const loadStatementRecords = async (
        page = mobilePage,
        search = searchQuery
    ) => {

        try {

            setLoadingCards(true);

            const token = localStorage.getItem("access_token");

            const headers = token
                ? { Authorization: `Bearer ${token}` }
                : {};

            const res = await API.get(
                "admin/feedback-statements/",
                {
                    params: {
                        page,
                        search,
                        type: "All"
                    },
                    headers
                }
            );

            setList(res.data.results || []);

            setMobileTotalPages(
                Math.ceil((res.data.count || 0) / 10)
            );

        } catch (err) {

            console.log(err);

        } finally {

            setLoadingCards(false);

        }

    };
    useEffect(() => {

        loadHelperData();

    }, []);

    useEffect(() => {

        if (!isMobile) return;

        loadStatementRecords(1, searchQuery);

    }, []);

    useEffect(() => {

        if (!isMobile) return;

        const timer = setTimeout(() => {

            setMobilePage(1);

            loadStatementRecords(
                1,
                searchQuery
            );

        }, 400);

        return () => clearTimeout(timer);

    }, [searchQuery]);

    useEffect(() => {

        if (!isMobile) return;

        loadStatementRecords(
            mobilePage,
            searchQuery
        );

    }, [mobilePage]);
        
    const loadHelperData = async () => {
        const token = localStorage.getItem('access_token');
        const config = token ? { headers: { 'Authorization': `Bearer ${token}` } } : {};
        try {
            const [courseRes, userRes] = await Promise.all([
                API.get('get-all-courses/', config),
                API.get('admin/users/registered/', config)
            ]);
            setCourses(courseRes.data);
            setUsers(userRes.data.results || userRes.data);
        } catch (err) {
            console.error("Error loading helper data:", err);
        }
    };

    // React.useEffect(() => { loadHelperData(); }, []);

    const handleEdit = (item) => {

        setFormData({
            courseid: item.courseid || '',
            feedbacktitle: item.feedbacktitle || '',
            feedbackdesc: item.feedbackdesc || '',
            userid: item.userid || ''
        });

        setSelectedId(item.statementid);

        setIsEditMode(true);

        setIsModalOpen(true);

    };

    const handleStatusToggle = async (item, refreshTable) => {
        try {
            await API.post(`admin/toggle-statement-status/${item.statementid}/`);
            toast.success("Status updated successfully.");
            if (refreshTable) {
                refreshTable();
            } else {
                loadStatementRecords(
                    mobilePage,
                    searchQuery
                );
            }

        } catch {

            toast.error("Status update failed");

        }

    };
    const handleFormSubmit = async (e) => {
        e.preventDefault();

        const payload = {
            ...formData
        };

        try {

            if (isEditMode) {

                await API.put(
                    `admin/feedback-statements/${selectedId}/`,
                    payload
                );

                toast.success("Updated Successfully!");

            } else {

                await API.post(
                    "admin/feedback-statements/",
                    payload
                );

                toast.success("Saved Successfully!");

            }

            setIsModalOpen(false);

            setIsEditMode(false);

            setSelectedId(null);

            refreshTableData();

        } catch (err) {

            console.error(err);

            toast.error("API Processing Error.");

        }
    };

    const gridHeaders = ['Course', 'Feedback Title', 'Feedback Description', 'Given by', 'Feed Back Date', 'Status', 'Action'];
    
    return (
        <div className="p-6 bg-[#F8FAFC] min-h-screen w-full font-sans">
            <div className="w-full max-w-8xl mx-auto space-y-4">
                <div className="text-center">
                    <h2 className="text-4xl font-light text-gray-700 mb-8">Feedback Statements</h2>
                </div>

                {/* <div className="flex justify-end">
                    <button onClick={() => { setIsEditMode(false); setFormData({courseid:'', feedbacktitle:'', feedbackdesc:'', userid:''}); setIsModalOpen(true); }} className="bg-[#032167] text-white px-5 py-2 rounded text-xs font-semibold hover:bg-blue-950 transition-all">Add New</button>
                </div> */}
                <div className="hidden md:block">
                <TableContainer
                    key={tableKey}
                    columns={gridHeaders}
                    apiUrl="admin/feedback-statements/"
                    searchQuery={searchQuery}
                    setSearchQuery={setSearchQuery}
                    renderRow={(item, index, srNo, formatCurrency, formatDollar, refreshTable) => (
                        <tr key={item.statementid || index} className="border-b text-xs text-gray-700 bg-white hover:bg-gray-50">
                            <td className="p-3 border-r text-center font-bold text-gray-400">{srNo}</td>
                            <td className="p-3 border-r text-left font-semibold text-[#032167]">{item.course_name || 'N/A'}</td>
                            <td className="p-3 border-r text-left">{item.feedbacktitle}</td>
                            <td className="p-3 border-r text-left">{item.feedbackdesc}</td>
                            <td className="p-3 border-r text-center">{item.given_by_user || 'N/A'}</td>
                            <td className="p-3 border-r text-center">{item.feedbackdate || 'N/A'}</td>
                            
                            <td className="p-3 border-r text-center">
                                <button type="button" onClick={() => handleStatusToggle(item, refreshTable)}>
                                    {item.status === 'A' ? <FaCheckCircle size={18} className="text-[#32b392]" /> : <FaMinusCircle size={18} className="text-red-400" />}
                                </button>
                            </td>

                            <td className="p-3 text-center">
                                <button onClick={() => handleEdit(item)} className="text-[#5c9314]"><FaEdit size={16} /></button>
                            </td>
                        </tr>
                    )}
                />
                </div>
                <div className="md:hidden mt-4">

                <input
                type="text"
                value={searchQuery}
                onChange={(e)=>setSearchQuery(e.target.value)}
                placeholder="Search feedback statement..."
                className="w-full border rounded-lg p-3 text-sm"
                />

                </div>
                <div className="md:hidden space-y-4 mt-4">

                {
                loadingCards ?

                <div className="text-center py-8">
                Loading...
                </div>

                :

                list.map(item=>(

                <div
                key={item.statementid}
                className="
                bg-white
                rounded-xl
                shadow-sm
                border
                p-4
                "
                >

                <div className="space-y-3">

                <div>

                <p className="text-xs text-gray-500">
                Course
                </p>

                <p className="font-bold">
                {item.course_name}
                </p>

                </div>

                <div>

                <p className="text-xs text-gray-500">
                Feedback Title
                </p>

                <p className="font-semibold">
                {item.feedbacktitle}
                </p>

                </div>

                <div>

                <p className="text-xs text-gray-500">
                Description
                </p>

                <p className="break-words">
                {item.feedbackdesc}
                </p>

                </div>

                <div>

                <p className="text-xs text-gray-500">
                Given By
                </p>

                <p>
                {item.given_by_user}
                </p>

                </div>

                <div>

                <p className="text-xs text-gray-500">
                Date
                </p>

                <p>
                {item.feedbackdate}
                </p>

                </div>

                <div>

                <p className="text-xs text-gray-500">
                Status
                </p>

                {
                item.status==="A"

                ?

                <span className="text-green-600 font-bold">
                Active
                </span>

                :

                <span className="text-red-600 font-bold">
                Inactive
                </span>

                }

                </div>

                <div className="flex justify-end gap-5 pt-2">

                <button
                onClick={()=>handleEdit(item)}
                className="text-green-700"
                >

                <FaEdit/>

                </button>

                <button
                onClick={()=>handleStatusToggle(item)}
                >

                {
                item.status==="A"

                ?

                <FaCheckCircle className="text-green-600"/>

                :

                <FaMinusCircle className="text-red-500"/>

                }

                </button>

                </div>

                </div>

                </div>

                ))

                }

                </div>
                <div className="md:hidden flex justify-between items-center py-5">

                <button
                disabled={mobilePage===1}
                onClick={()=>setMobilePage(p=>p-1)}
                className="px-4 py-2 border rounded"
                >

                Previous

                </button>

                <span>

                Page {mobilePage} of {mobileTotalPages}

                </span>

                <button
                disabled={mobilePage===mobileTotalPages}
                onClick={()=>setMobilePage(p=>p+1)}
                className="px-4 py-2 border rounded"
                >

                Next

                </button>

                </div>
            </div>

            {/* Modal */}
            {isModalOpen && (
                <div
                className="
                fixed
                inset-0
                z-[6000]
                bg-black/60
                backdrop-blur-sm
                flex
                items-start
                pt-6
                justify-center
                overflow-y-auto
                p-4
                "
                >
                    <div
                    className="
                    relative
                    bg-white
                    w-full
                    max-w-lg
                    rounded-2xl
                    shadow-2xl
                    flex
                    flex-col
                    overflow-hidden
                    mx-2
                    md:mx-0
                    max-h-[85vh]
                    "
                    >

                        <div
                        className="
                        bg-[#032167]
                        text-white
                        px-5
                        py-4
                        flex
                        justify-between
                        items-center
                        flex-shrink-0
                        "
                        >

                        <h3 className="font-bold uppercase text-sm">

                        {isEditMode
                        ? "Modify Feedback Statement"
                        : "Add Feedback Statement"}

                        </h3>

                        <button
                        type="button"
                        onClick={()=>setIsModalOpen(false)}
                        className="text-white hover:text-red-300"
                        >

                        <FaTimes size={18}/>

                        </button>

                        </div>
                        <form
                        onSubmit={handleFormSubmit}
                        className="
                        flex-1
                        overflow-y-auto
                        p-4
                        md:p-6
                        space-y-5
                        min-h-0
                        "
                        >
                            <select className="w-full
                            rounded-lg
                            border
                            border-gray-300
                            p-3
                            bg-white
                            text-sm
                            outline-none
                            focus:border-blue-500
                            " value={formData.courseid} onChange={e => setFormData({...formData, courseid: e.target.value})} required>
                                <option value="">-- Choose Course --</option>
                                {courses.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                            </select>
                            <input className="
                            w-full
                            rounded-lg
                            border
                            border-gray-300
                            p-3
                            text-sm
                            bg-white
                            focus:border-blue-500
                            outline-none
                            " placeholder="Title" value={formData.feedbacktitle} onChange={e => setFormData({...formData, feedbacktitle: e.target.value})} required />
                            <textarea rows={5}
                            className="
                            w-full
                            border
                            border-gray-300
                            rounded-lg
                            p-3
                            resize-none
                            
                            " placeholder="Description" value={formData.feedbackdesc} onChange={e => setFormData({...formData, feedbackdesc: e.target.value})} required />
                            <select className="w-full p-2 border" value={formData.userid} onChange={e => setFormData({...formData, userid: e.target.value})} required>
                                <option value="">-- Choose User --</option>
                                {users.map(u => <option key={u.userid} value={u.userid}>{u.name}</option>)}
                            </select>
                            <div className="pt-2">

                            <button
                            type="submit"
                            className="
                            w-full
                            py-3
                            rounded-lg
                            bg-[#032167]
                            text-white
                            font-bold
                            shadow
                            hover:bg-blue-900
                            transition
                            "
                            >

                            {isEditMode ? "UPDATE" : "SAVE"}

                            </button>

                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AddFeedbackStatementDetails;